import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VSheet,
    {
      staticClass: "attached-files d-flex flex-column gr-4",
      attrs: { "data-qa": "attached_files" },
    },
    [
      _c("div", { staticClass: "text-subtitle-1 text--text" }, [
        _vm._v("\n    Обязательно загрузите направление\n  "),
      ]),
      _vm._v(" "),
      _setup.attachedFilesStore.attachedFiles.length
        ? _c(
            "div",
            {
              staticClass: "d-flex flex-wrap ga-4",
              attrs: { "data-qa": "attached_files_previews" },
            },
            _vm._l(
              _setup.attachedFilesStore.attachedFiles,
              function (attachedFile) {
                return _c(_setup.FilePreview, {
                  key: attachedFile.id,
                  attrs: {
                    file: attachedFile.file,
                    status: attachedFile.status,
                    size: 80,
                    "hide-on-leave": _setup.isExceededAttachedFiles,
                  },
                  on: {
                    delete: function ($event) {
                      return _setup.attachedFilesStore.deleteAttachedFile(
                        attachedFile
                      )
                    },
                    retry: function ($event) {
                      return _setup.retrySend(attachedFile)
                    },
                  },
                })
              }
            ),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        VExpandTransition,
        [
          _c(_setup.CoreFilePicker, {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_setup.isExceededAttachedFiles,
                expression: "!isExceededAttachedFiles",
              },
            ],
            ref: "coreFilePickerRef",
            attrs: {
              "accept-file-types":
                _setup.VALIDATION_OPTIONS.allowedFileMimeTypes,
              disabled: _setup.isExceededAttachedFiles,
              "file-validation-rules": _setup.fileValidationRules,
              "image-validation-rules": _setup.imageValidationRules,
              "is-convert-to-base64": "",
            },
            on: {
              "validation-error": function ($event) {
                return _setup.alertDialogRef.open($event)
              },
              "pick-file-error": function ($event) {
                return _setup.alertDialogRef.open(_setup.pickFileError)
              },
              input: _setup.handleInputFilePicker,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ focused, disabled }) {
                  return [
                    _c(_setup.FilePickerActivator, {
                      attrs: {
                        text: _setup.fileActivatorText,
                        focused: focused,
                        disabled: disabled,
                        "is-error": _setup.attachedFilesStore.isErrorState,
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VExpandTransition,
        [
          _setup.isVisibleBannerOriginalDocuments
            ? _c(_setup.BannerInfo, [
                _c("div", { staticClass: "text-body-2 text--text" }, [
                  _vm._v(
                    "\n        Не забудьте взять оригинал направления на приём\n      "
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.AlertDialog, { ref: "alertDialogRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }